export const TAG_ZH_TO_EN = {
  独家: 'exclusive',
  hot: 'hot',
  new: 'new'

};
